<template>
  <v-layout>
    <v-col v-if="Push.isForm" cols :sm="12" class="pa-0">
      <v-form v-model="Push.isValid" ref="form">
        <v-card flat class="pt-5">
          <v-layout align-center class="px-3">
            <h2>{{ $t("menu.push") }}</h2>
            <v-spacer></v-spacer>
            <v-icon @click="_fnReset()" color="primary"> mdi-close </v-icon>
          </v-layout>
          <v-card-text>
            <v-row>
              <v-col cols :sm="6" class="py-0">
                <v-text-field
                  color="primary"
                  :rules="[Rules.required]"
                  v-model="Push.obj.titleVI"
                >
                  <template #label>
                    {{ $t(`table.title`) + " (VI)" }}
                    <span class="red--text"><b>*</b></span>
                  </template>
                </v-text-field>
              </v-col>
              <v-col cols :sm="6" class="py-0">
                <v-text-field
                  color="primary"
                  :rules="[Rules.required]"
                  v-model="Push.obj.titleEN"
                >
                  <template #label>
                    {{ $t(`table.title`) + " (EN)" }}
                    <span class="red--text"><b>*</b></span>
                  </template>
                </v-text-field>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols :sm="6" class="py-0">
                <v-statusPush
                  v-model="Push.obj.status"
                  :rules="[Rules.required]"
                />
              </v-col>
              <v-col cols :sm="6" class="py-0">
                <v-dateTimePicker
                  v-model="Push.obj.startTime"
                  :rules="[Rules.dateTime]"
                  :label="$t(`table.startTime`)"
                />
              </v-col>
            </v-row>
            <v-row>
              <v-col cols :sm="6" class="py-0 mb-3">
                <v-upload
                  :width="450"
                  :height="250"
                  class="mb-3"
                  :label="$t(`table.cover`)"
                  v-model="Push.obj.cover"
                  :rules="[Rules.required]"
                />
              </v-col>
              <v-col cols :sm="6" class="py-0 mb-3">
                <v-row>
                  <v-col cols :sm="12" class="py-5">
                    <v-checkbox
                      color="primary"
                      :label="$t(`table.isNow`)"
                      hide-details
                      v-model="Push.obj.isNow"
                    ></v-checkbox>
                  </v-col>
                  <v-col cols :sm="12" class="py-0">
                    <v-textarea
                      rows="7"
                      color="primary"
                      v-model="Push.obj.userIdPush"
                    >
                      <template #label>
                        {{ "User ID Test" }}
                      </template>
                    </v-textarea>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols :sm="6" class="py-0">
                <v-textarea color="primary" v-model="Push.obj.descriptionVI">
                  <template #label>
                    {{ $t(`table.description`) + " (VI)" }}
                  </template>
                </v-textarea>
              </v-col>
              <v-col cols :sm="6" class="py-0">
                <v-textarea color="primary" v-model="Push.obj.descriptionEN">
                  <template #label>
                    {{ $t(`table.description`) + " (EN)" }}
                  </template>
                </v-textarea>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols :sm="12" class="py-0">
                <v-editor
                  :label="$t(`table.content`) + ' (VI)'"
                  v-model="Push.obj.contentVI"
                  :rules="[Rules.required]"
                />
              </v-col>
            </v-row>
            <v-row>
              <v-col cols :sm="12" class="py-0">
                <v-editor
                  :label="$t(`table.content`) + ' (EN)'"
                  v-model="Push.obj.contentEN"
                  :rules="[Rules.required]"
                />
              </v-col>
            </v-row>
          </v-card-text>
          <v-card-actions class="px-4">
            <v-spacer></v-spacer>
            <v-btn
              color="primary"
              :disabled="!Push.isValid"
              @click="Push.isCreate ? _fnCreate() : _fnUpdate()"
              >{{ Push.isCreate ? $t(`table.create`) : $t(`table.update`) }}
            </v-btn>
            <v-btn outlined color="primary" @click="_fnReset()">
              {{ $t(`table.cancel`) }}
            </v-btn>
            <v-spacer></v-spacer>
          </v-card-actions>
        </v-card>
      </v-form>
    </v-col>

    <v-dialog
      v-if="Push.isDelete"
      v-model="Push.isDelete"
      persistent
      scrollable
      max-width="500"
    >
      <v-card>
        <v-card-title dense class="headline primary" />
        <v-card-text class="pt-2">
          {{ $t(`table.deleteMess`) }}
          <b>{{ Push.obj.title }}</b>
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn color="primary" @click="_fnDelete()">
            {{ $t(`table.delete`) }}
          </v-btn>
          <v-btn outlined color="primary" @click="_fnReset()">
            {{ $t(`table.cancel`) }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-layout>
</template>

<script>
export default {
  data: () => ({
    model: "Push",
  }),
  methods: {
    _fnReset() {
      if (this.$refs.form) this.$refs.form.reset();
      this.fnResetFlagView(this.model);
    },
    _fnReFresh() {
      this._fnReset();
      this[this.model].isRefresh = true;
    },
    async _fnCreate() {
      const { code } = await this.fnPost({
        url: `/v1/admin/push`,
        model: this.model,
      });
      if (code === 200) {
        this._fnReFresh();
      }
    },
    async _fnUpdate() {
      const { code } = await this.fnPut({
        url: `/v1/admin/push/${this[this.model].obj.id}`,
        model: this.model,
      });
      if (code === 200) {
        this._fnReFresh();
      }
    },
    async _fnDelete() {
      const { code } = await this.fnDelete({
        url: `/v1/admin/push/${this[this.model].obj.id}`,
        model: this.model,
      });
      if (code === 200) {
        this._fnReFresh();
      }
    },
  },
};
</script>
